
// // ############################################

// import React, { useEffect, useState, useRef } from "react";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import SelectPrimaryProfile from "../SelectOwnProfile";
// import SelectEntity from "../SelectEntity";
// import SocialPopup from "../SocialPopup";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import IconButton from "@mui/material/IconButton";
// import ConnectPrimaryProfile from "layouts/components/ConnectOwnProfile";
// import ReviewAndGenerateSnapshot from "../ReviewAndGenerateSnapshot";
// import UserService from "services/user-service";
// import dayjs from "dayjs";
// import CircularProgress from "@mui/material/CircularProgress";
// import SnapshotStepper from "../Stepper/SnapshotStepper";

// const steps = ["Select Primary Profile", "Select Campaign Entities", "Review & Generate Snapshot"];

// function CampaignSnapshot({ goBack, onComplete }) {
//   const [selectedPrimaryProfile, setSelectedPrimaryProfile] = useState(null);
//   const [selectedEntities, setSelectedEntities] = useState([]);
//   const [step, setStep] = useState(1);
//   const [showConnectDialog, setShowConnectDialog] = useState(false);
//   const snapshotConfigRef = useRef({});
//   const [isSaving, setIsSaving] = useState(false);

//   // ⬇️ --- (Removed toolbarTop state) ---

//   // ✅ --- (Added navHeight and isTransparent) ---
//   const [navHeight, setNavHeight] = useState(75); // Default height
//   const [isTransparent, setIsTransparent] = useState(true);

//   // ⬇️ --- (Removed old complex useEffect) ---

//   // ✅ --- (Added new useEffect for navbar height) ---
//   useEffect(() => {
//     const navbarEl = document.querySelector("header.MuiAppBar-root");
//     if (navbarEl) setNavHeight(navbarEl.offsetHeight);

//     const resizeObserver = new ResizeObserver(() => {
//       if (navbarEl) setNavHeight(navbarEl.offsetHeight);
//     });

//     if (navbarEl) resizeObserver.observe(navbarEl);
//     return () => resizeObserver.disconnect();
//   }, []);

//   // ✅ --- (Added new useEffect for scroll shadow) ---
//   useEffect(() => {
//     const handleScroll = () => setIsTransparent(window.scrollY === 0);
//     window.addEventListener("scroll", handleScroll);
//     handleScroll(); // initial setup
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // ✅ Reset selected entities when primary profile changes
//   useEffect(() => {
//     if (step === 1) {
//       setSelectedEntities([]);
//     }
//   }, [selectedPrimaryProfile]); // Dependency added for clarity

//   // (This OAuth useEffect remains unchanged)
//   useEffect(() => {
//     const intent = localStorage.getItem("postOAuthIntent");
//     const confirmed = localStorage.getItem("postOAuthConfirmed");

//     if (intent === "campaign" && confirmed === "true") {
//       console.log("🔁 Detected campaign snapshot OAuth flow — refreshing primary profiles...");
//       localStorage.removeItem("postOAuthIntent");
//       localStorage.removeItem("postOAuthConfirmed");

//       setShowConnectDialog(false);
//       setTimeout(() => {
//         primaryProfileRef.current?.refreshProfiles?.();
//       }, 350);
//     }
//   }, []);

//   const handleContinue = async () => {
//     if (step === 1) {
//       setStep(2);
//     } else if (step === 2) {
//       setStep(3);
//     } else {
//       setIsSaving(true);
//       try {
//         const snapshotInfo = {
//           snapshotType: "Campaign",
//           snapshotName: snapshotConfigRef.current.snapshotName,
//           emails: snapshotConfigRef.current.email
//             ?.split(",")
//             .map((e) => e.trim())
//             .filter(Boolean),
//           primaryProfile: {
//             profileId: selectedPrimaryProfile.id,
//             platform: selectedPrimaryProfile.platform,
//           },
//           secondaryProfiles: [],
//           primaryEntities: selectedEntities.map((entity) => ({
//             ...entity,
//             profileId: selectedPrimaryProfile.id,
//             platform: selectedPrimaryProfile.platform,
//           })),
//           secondaryEntities: [],
//           frequency: snapshotConfigRef.current.scheduleMonthly ? "monthly" : "once",
//           scheduleEnabled: snapshotConfigRef.current.scheduleMonthly,
//           rangeStart: dayjs().subtract(1, "month").startOf("month").toDate(),
//           rangeEnd: dayjs().subtract(1, "month").endOf("month").toDate(),
//           nextRunAt: snapshotConfigRef.current.scheduleMonthly
//             ? dayjs().endOf("month").add(1, "day").startOf("day").toDate()
//             : null,
//         };
//         const result = await UserService.saveUserSnapshot(snapshotInfo);
//         console.log("✅ Campaign Snapshot saved:", result);
//         onComplete();
//       } catch (err) {
//         console.error("❌ Failed to save Campaign snapshot:", err);
//       } finally {
//         setIsSaving(false);
//       }
//     }
//   };

//   const handleClear = () => {
//     if (step === 1) setSelectedPrimaryProfile(null);
//     if (step === 2) setSelectedEntities([]);
//   };

//   const selectedProfiles =
//     step === 2 ? selectedEntities : selectedPrimaryProfile ? [selectedPrimaryProfile] : [];

//   if (isSaving) {
//     return (
//       <MDBox textAlign="center" pt={6}>
//         <CircularProgress />
//         <MDTypography mt={2}>Saving snapshot, please wait...</MDTypography>
//       </MDBox>
//     );
//   }

//   return (
//     <MDBox textAlign="center" mt={-6}>
//       <MDBox
//         display="flex"
//         alignItems="center"
//         justifyContent="flex-start"
//         width="100%"
//         // ⬇️ --- (Removed redundant props) ---
//         zIndex={1000}
//         bgcolor="white"
//         py={1}
//         px={1}
//         boxShadow={1}
//         sx={{
//           position: "sticky",
//           // ✅ --- (Changed top value to use navHeight) ---
//           top: `${navHeight - 1}px`,
//           zIndex: 999,
//           backgroundColor: "#ffffff",
//           padding: "5px",
//           borderRadius: "8px",
//           gap: 2,
//           mb: 0,
//           boxShadow: isTransparent ? "none" : "0 4px 12px rgba(0, 0, 0, 0.2)",
//           transition: "top 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
//         }}
//       >
//         <IconButton
//           onClick={step === 1 ? goBack : () => setStep(step - 1)}
//           sx={{ color: "primary.main", ml: 1 }}
//         >
//           <ArrowBackIcon />
//         </IconButton>

//         <MDBox flexGrow={1} pl={2}>
//           <SnapshotStepper steps={steps} activeStep={step - 1} />
//         </MDBox>
//       </MDBox>

//       {step === 1 && (
//         <SelectPrimaryProfile
//           selectedProfileId={selectedPrimaryProfile?.id}
//           onSelect={(profile) => setSelectedPrimaryProfile(profile)}
//           onAddProfileClick={() => setShowConnectDialog(true)}
//         />
//       )}

//       {step === 2 && (
//         <SelectEntity
//           profile={selectedPrimaryProfile}
//           selectedEntities={selectedEntities}
//           onSelect={(entities) => setSelectedEntities(entities)}
//         />
//       )}

//       {step === 3 && (
//         <MDBox pt={6} pb={3}>
//           <ReviewAndGenerateSnapshot
//             snapshotType="Campaign"
//             primaryProfile={selectedPrimaryProfile}
//             campaignEntities={selectedEntities}
//             snapshotConfigRef={snapshotConfigRef}
//           />
//         </MDBox>
//       )}

//       <SocialPopup
//         selectedItems={selectedProfiles}
//         onClearConfirm={step < 3 ? handleClear : undefined}
//         onContinue={handleContinue}
//         onBack={step === 1 ? goBack : () => setStep(step - 1)}
//         actionLabel={step === 3 ? "Generate Snapshot" : "Continue"}
//         entityType={
//           step === 2
//             ? selectedPrimaryProfile?.platform === "YouTube"
//               ? "video"
//               : "post"
//             : "profile"
//         }
//       />

//       <ConnectPrimaryProfile
//         open={showConnectDialog}
//         onClose={() => setShowConnectDialog(false)}
//         flowIntent="campaign"
//       />
//     </MDBox>
//   );
// }

// export default CampaignSnapshot;




import React, { useEffect, useState, useRef } from "react";
import WorkspaceService from "services/workspace-service";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SelectPrimaryProfile from "../SelectOwnProfile";
import SelectEntity from "../SelectEntity";
import SocialPopup from "../SocialPopup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import ConnectPrimaryProfile from "layouts/components/ConnectOwnProfile";
import ReviewAndGenerateSnapshot from "../ReviewAndGenerateSnapshot";
import UserService from "services/user-service";
import dayjs from "dayjs";
import CircularProgress from "@mui/material/CircularProgress";
import SnapshotStepper from "../Stepper/SnapshotStepper";
import MDSnackbar from "components/MDSnackbar";
import SnapshotService from "services/snapshot-service";
// import SnapshotLoading from "../SnapshotLoading"; // [DELETE]

const steps = [
  "Select Snapshot Type", // ✅ inherited as completed from parent
  "Select Primary Profile",
  "Select Campaign Entities",
  "Review & Save Snapshot",
];

function CampaignSnapshot({ goBack, onComplete, editSnapshotData, isLiveDemo, showGuidance }) {
  const [selectedPrimaryProfile, setSelectedPrimaryProfile] = useState(null);
  const [selectedEntities, setSelectedEntities] = useState([]);
  const [step, setStep] = useState(1); // internal current step (primary)
  const [showConnectDialog, setShowConnectDialog] = useState(false);
  const snapshotConfigRef = useRef({});
  const [isSaving, setIsSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showEmailError, setShowEmailError] = useState(false); // [NEW] Inline error state

  const openErrorSB = (msg) => {
    setErrorMessage(msg);
    setErrorSB(true);
  };
  const closeErrorSB = () => setErrorSB(false);
  const primaryProfileRef = useRef();

  // [NEW] Combined flag for highlights
  const enableDemoHighlight = isLiveDemo && showGuidance;


  // ───────────────────────────────
  // 🟢 Prefill data if editing snapshot
  // ───────────────────────────────
  useEffect(() => {
    if (editSnapshotData) {
      console.log("🟡 Editing existing Campaign Snapshot:", editSnapshotData);

      setIsEditing(true);
      setStep(4); // campaign snapshot has 4 steps, skip to review

      snapshotConfigRef.current.snapshotId = editSnapshotData._id || editSnapshotData.snapshotId;
      snapshotConfigRef.current.snapshotName = editSnapshotData.snapshot_name || editSnapshotData.snapshotName;

      // ✅ Handle recipient_emails from backend vs email field in config
      if (Array.isArray(editSnapshotData.recipient_emails)) {
        snapshotConfigRef.current.email = editSnapshotData.recipient_emails.join(", ");
      } else {
        snapshotConfigRef.current.email = editSnapshotData.recipient_emails || editSnapshotData.email || "";
      }
      snapshotConfigRef.current.scheduleMonthly = editSnapshotData.scheduleMonthly;

      if (editSnapshotData.primaryProfile) {
        setSelectedPrimaryProfile(editSnapshotData.primaryProfile);
      }
      if (Array.isArray(editSnapshotData.entities)) {
        setSelectedEntities(editSnapshotData.entities);
      }
    }
  }, [editSnapshotData]);

  const [navHeight, setNavHeight] = useState(75);
  const [isTransparent, setIsTransparent] = useState(true);

  // ───────────────────────────────────────────────
  // Navbar height tracking
  // ───────────────────────────────────────────────
  useEffect(() => {
    const navbarEl = document.querySelector("header.MuiAppBar-root");
    if (navbarEl) setNavHeight(navbarEl.offsetHeight);

    const resizeObserver = new ResizeObserver(() => {
      if (navbarEl) setNavHeight(navbarEl.offsetHeight);
    });
    if (navbarEl) resizeObserver.observe(navbarEl);
    return () => resizeObserver.disconnect();
  }, []);

  // Shadow toggle on scroll
  useEffect(() => {
    const handleScroll = () => setIsTransparent(window.scrollY === 0);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // OAuth handling for post-login profile refresh
  useEffect(() => {
    const intent = localStorage.getItem("postOAuthIntent");
    const confirmed = localStorage.getItem("postOAuthConfirmed");

    if (intent === "campaign" && confirmed === "true") {
      console.log("🔁 OAuth detected — refreshing primary profiles...");
      localStorage.removeItem("postOAuthIntent");
      localStorage.removeItem("postOAuthConfirmed");

      setShowConnectDialog(false);
      setTimeout(() => {
        primaryProfileRef.current?.refreshProfiles?.();
      }, 350);
    }
  }, []);

  // Reset selected entities when primary profile changes
  useEffect(() => {
    if (step === 1) setSelectedEntities([]);
  }, [selectedPrimaryProfile]);

  // ───────────────────────────────────────────────
  // Step navigation handlers
  // ───────────────────────────────────────────────
  const handleContinue = async () => {
    if (step === 1) return setStep(2);
    if (step === 2) return setStep(3);

    if (step === 3) {
      // 🛡️ [VALIDATION] Ensure emails are provided if immediate send is checked
      const emailsArr = snapshotConfigRef.current.email
        ?.split(",")
        .map((e) => e.trim())
        .filter(Boolean);

      if ((snapshotConfigRef.current.sendSnapshotImmediately || snapshotConfigRef.current.scheduleMonthly) && (!emailsArr || emailsArr.length === 0)) {
        setShowEmailError(true);
        return;
      }

      setIsSaving(true);
      try {
        const snapshotInfo = {
          snapshotType: "Campaign",
          snapshotName: snapshotConfigRef.current.snapshotName,
          emails: snapshotConfigRef.current.email
            ?.split(",")
            .map((e) => e.trim())
            .filter(Boolean),
          primaryProfile: {
            profileId: selectedPrimaryProfile.id,
            platform: selectedPrimaryProfile.platform,
          },
          secondaryProfiles: [],
          primaryEntities: selectedEntities.map((entity) => ({
            ...entity,
            profileId: selectedPrimaryProfile.id,
            platform: selectedPrimaryProfile.platform,
          })),
          secondaryEntities: [],
          frequency: snapshotConfigRef.current.scheduleMonthly ? "monthly" : "once",
          scheduleEnabled: snapshotConfigRef.current.scheduleMonthly,
          rangeStart: dayjs().subtract(1, "month").startOf("month").toDate(),
          rangeEnd: dayjs().subtract(1, "month").endOf("month").toDate(),
          nextRunAt: snapshotConfigRef.current.scheduleMonthly
            ? dayjs().endOf("month").add(1, "day").startOf("day").toDate()
            : null,
          branding_pack_id: snapshotConfigRef.current.branding_pack_id || null, // [FIX] Include selected branding pack
          target_client: snapshotConfigRef.current.target_client || null,        // [FIX] Include target client
        };

        if (!isLiveDemo) {
          await WorkspaceService.saveWorkspaceSnapshot(snapshotInfo);
          console.log("✅ Campaign Snapshot saved successfully");
        } else {
          console.log("⚠️ Live Demo: Downloading Campaign Snapshot PDF locally instead of saving");
          await SnapshotService.generateCampaignSnapshot(snapshotInfo);
        }

        // 📧 Handle Immediate Email Dispatch [NEW]
        console.log("🔍 [DEBUG] sendSnapshotImmediately:", snapshotConfigRef.current.sendSnapshotImmediately);
        if (snapshotConfigRef.current.sendSnapshotImmediately) {
          console.log("🚀 [DEBUG] User requested immediate snapshot email. Payload:", { snapshotInfo, emails: snapshotInfo.emails });
          try {
            const emailRes = await SnapshotService.emailSnapshot(snapshotInfo, snapshotInfo.emails);
            console.log("✅ [DEBUG] Immediate snapshot email response:", emailRes);
          } catch (emailErr) {
            console.error("⚠️ [DEBUG] Immediate snapshot email failed:", emailErr);
          }
        }

        onComplete();
      } catch (err) {
        console.error("❌ Failed to save Campaign Snapshot:", err);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Validation Error"
      content={errorMessage}
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  const handleBack = () => {
    if (step === 1) return goBack();

    // Clear inline error if going back from review step
    if (step === 3) setShowEmailError(false);

    setStep(step - 1);
  };

  const handleClear = () => {
    if (step === 1) setSelectedPrimaryProfile(null);
    if (step === 2) setSelectedEntities([]);
  };

  // ───────────────────────────────────────────────
  // Popup selection logic
  // ───────────────────────────────────────────────
  const selectedItems =
    step === 2
      ? selectedEntities
      : selectedPrimaryProfile
        ? [selectedPrimaryProfile]
        : [];

  // ───────────────────────────────────────────────
  // Loading State - [MOVED TO BUTTON LEVEL]
  // ───────────────────────────────────────────────

  // ───────────────────────────────────────────────
  // Render
  // ───────────────────────────────────────────────
  return (
    <MDBox textAlign="center" mt={-5}>
      {/* Sticky Stepper Toolbar */}
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        bgcolor="white"
        py={1}
        px={1}
        sx={{
          position: "sticky",
          top: `${navHeight - 1}px`,
          zIndex: 999,
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          gap: 2,
          mb: 1,
          boxShadow: isTransparent
            ? "none"
            : "0 4px 12px rgba(0, 0, 0, 0.2)",
          transition:
            "top 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
        }}
      >
        <IconButton onClick={handleBack} sx={{ color: "primary.main", ml: 1 }}>
          <ArrowBackIcon />
        </IconButton>

        <MDBox flexGrow={1} pl={2}>
          {/* 👇 Stepper shows parent step as completed */}
          <SnapshotStepper steps={steps} activeStep={step} />
        </MDBox>
      </MDBox>

      {/* Step 1: Select Primary Profile */}
      {step === 1 && (
        <SelectPrimaryProfile
          ref={primaryProfileRef}
          selectedProfileId={selectedPrimaryProfile?.id}
          onSelect={(profile) => setSelectedPrimaryProfile(profile)}
          onAddProfileClick={() => setShowConnectDialog(true)}
          isDemoHighlight={enableDemoHighlight} // [NEW]
        />
      )}

      {/* Step 2: Select Campaign Entities */}
      {step === 2 && (
        <SelectEntity
          profile={selectedPrimaryProfile}
          selectedEntities={selectedEntities}
          onSelect={(entities) => setSelectedEntities(entities)}
          isDemoHighlight={enableDemoHighlight} // [NEW]
        />
      )}

      {step === 3 && (
        <MDBox pt={6} pb={3}>
          <ReviewAndGenerateSnapshot
            snapshotType="Campaign"
            primaryProfile={selectedPrimaryProfile}
            campaignEntities={selectedEntities}
            snapshotConfigRef={snapshotConfigRef}
            forceEmailError={showEmailError} // [NEW]
            onSave={handleContinue}
            onCancel={handleBack}
            isSaving={isSaving}
            demoHighlight={enableDemoHighlight} // [NEW]
            isLiveDemo={isLiveDemo} // [NEW]
          />
        </MDBox>
      )}

      {/* Floating Popup (Hidden in Step 3 review to avoid double buttons) */}
      {step < 3 && (
        <SocialPopup
          selectedItems={selectedItems}
          onClearConfirm={step < 3 ? handleClear : undefined}
          onContinue={handleContinue}
          onBack={handleBack}
          actionLabel={step === 3 ? "Save Snapshot" : "Continue"}
          entityType={
            step === 2
              ? selectedPrimaryProfile?.platform === "YouTube"
                ? "video"
                : "post"
              : "profile"
          }
          isSaving={isSaving}
          demoHighlight={
            enableDemoHighlight &&
            ((step === 1 && !!selectedPrimaryProfile) || (step === 2 && selectedEntities.length > 0) || step === 3)
          }
          allowDemoAction={true}
        />
      )}

      {/* Connect Primary Profile Dialog */}
      <ConnectPrimaryProfile
        open={showConnectDialog}
        onClose={() => setShowConnectDialog(false)}
        flowIntent="campaign"
      />
      {renderErrorSB}
    </MDBox>
  );
}

export default CampaignSnapshot;
